import { render, staticRenderFns } from "./RegisterMonitor.vue?vue&type=template&id=9c1c4860&scoped=true&"
import script from "./RegisterMonitor.vue?vue&type=script&lang=js&"
export * from "./RegisterMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1c4860",
  null
  
)

export default component.exports